module.exports = __webpack_public_path__ + "static/media/share-social-badge.470f5647.svg";